import { NavbarComponent } from '../Navbar';
import Footer from '../Footer';
import { projectConfig } from '../../config/project';
import { cn } from '../../utils/cn';

export interface PublicLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col min-h-screen',
        className || ''
      )}
      style={{ backgroundColor: 'var(--color-background-default)' }}
    >
      <NavbarComponent projectName={projectConfig.name} />

      <main
        className="flex-1 min-w-0 overflow-x-hidden relative"
        style={{ backgroundColor: 'var(--color-background-default)' }}
      >
        <div className="h-full w-full">{children}</div>
      </main>

      <Footer />
    </div>
  );
};


